import { connect } from "react-redux";
import Blog from "../../common/Blog";
import { actionCreators } from "../Blog/action";

const mapStateToProps = (state) => {
  const pageData = state.manipulation && state.manipulation;
  return { pageData };
};

function mapDispatchToProps(dispatch) {
  const callToData = () =>  dispatch(actionCreators.get('manipulation'));
  return { callToData };
}

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
